import type { LogAttributes } from './logger.interface';

const DEFAULT_KEYS_TO_REDACT = [
  'authorization',
  'password',
  'email',
  'username',
  'X-Shopify-Access-Token',
  'api_key',
  'api-key',
].map((s) => s.toLowerCase());

const KEYS_TO_REDACT = new Set<string>(DEFAULT_KEYS_TO_REDACT);

/**
 * Determine if a key is sensitive and should be redacted in logs.
 */
export const isSensitiveKey = (key: string): boolean => {
  return KEYS_TO_REDACT.has(key.toLowerCase());
};

/**
 * Desensitize log attributes by redacting sensitive information and flattening
 * Error objects.
 */
export const desensitizeObjectValues = (attributes: LogAttributes) => {
  const serializedAttributes: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(attributes)) {
    // Redact sensitive keys
    if (isSensitiveKey(key)) {
      serializedAttributes[key] = '[REDACTED]';
      continue;
    }

    // Flatten error objects since stringifying them directly results in `{}`
    if (value instanceof Error) {
      serializedAttributes[key] = {
        message: value.message,
        name: value.name,
        stack: value.stack,
      };
      continue;
    }

    serializedAttributes[key] = value;
  }

  return serializedAttributes;
};
